import React, { useEffect, useRef, useState } from "react";
import CommonGrid from '../../../Components/common/CommonGrid'
import Dropdown from 'react-bootstrap/Dropdown';
import Trash from "../../../assets/images/trash.png";
import Info from "../../../assets/images/info.png";
import RedCross from "../../../assets/images/close.png";
import edit from "../../../assets/images/edit.png";
import view from "../../../assets/images/view.png";
import user from "../../../assets/images/superadmin/user_view.png";
import switc from "../../../assets/images/superadmin/switch.png";
import reset from "../../../assets/images/superadmin/reset.png";
import authn from "../../../assets/images/superadmin/Google_Authenticator.png";
import { faChevronDown, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactSearchAutocomplete } from "react-search-autocomplete";

import { withRFSToken } from '../../../Services/axios.js';
import { toast } from 'react-toastify';
import { handleRedirect } from './HandleRedirect.js';
import UserManage from "./UserManage.js";
import { CallApi, CommonModal } from "../../../Components/common/CommonFunctions.js";
import { Button, Col, Form, Row } from "react-bootstrap";
import Select from 'react-select'
import { GETDESTINATION, GETOWNERCODE } from "../../../Utils/conts.js";
import ConfModal from "../../../Components/common/ConfModal.js";
import { AddSession } from "../../../useAuth/SessionExtract.js";
import { useHistory, useLocation } from 'react-router-dom';

const Organisation = () => {

    const isMounted = useRef(false);
    const history = useHistory()
    const location = useLocation();
    const [userManage, setUserManage] = useState(false)
    const [reload, setReload] = useState(false)
    const [userData, setUserData] = useState('')
    const [confModal, setConfModal] = useState(false);
    const [modalConf, setModalConf] = useState(false);
    const [modalData, setModalData] = useState({});
    const [searchValue, setSearchValue] = useState({});
    const [modalPos, setModalPos] = useState();
    const [getDestination, setGetDestination] = useState([]);
    const [getAorgName, setGetAorgName] = useState([]);

    const orgType = [
        { label: 'Airline', value: 'A' },
        { label: 'Forwarder', value: 'E' },
        { label: 'Handler', value: 'H' },
        { label: 'Trucking', value: 'T' },
    ]
    const datafields = [
        { name: 'org_id', type: 'string' },
        { name: 'org_Name', type: 'string' },
        { name: 'org_Type', type: 'string' },
        { name: 'org_type', type: 'string' },
        { name: 'register_date', type: 'string' },
        { name: 'activity_status', type: 'string' },
        { name: 'auth', type: 'string' },

    ];

    const fetchOwnerCode = () => {
        CallApi({
            endPoint: GETOWNERCODE,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                const transformedData = innerData ? innerData.map(item => ({
                    id: item.IATA,
                    name: item.airline_name
                })) : [];
                setGetAorgName(transformedData);
            },
            onError: (msg) => {
                toast.error(msg)
            }
        });
    };
    const fetchDestination = () => {
        CallApi({
            endPoint: GETDESTINATION,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                const transformedData = innerData ? innerData.map(item => ({
                    value: item.port_code,
                    label: item.port_code,
                    address: item.address,
                    station_id: item.station_id
                })) : [];
                setGetDestination(transformedData);
            },
            onError: (msg) => {
                toast.error(msg)
            }
        });
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetchOwnerCode();
        fetchDestination();
        isMounted.current = true;
    }, []);

    const columns = [
        {
            text: 'Activities',
            cellsrenderer: function () {
                return '<div class="grid_actions jqx-grid-cell-left-align"><img src="' + view + '" class="row_view" /> <img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_delete" /></div>';
            },
            width: '8%', filterable: false,
        },
        // {
        //     text: 'Organization Name', filtertype: 'textbox', datafield: 'airway_bill', width: '15%', cellclassname: '',
        //     cellclassname: (row, column, value, rowData) => {
        //         if (rowData.colour_status == 'G') {
        //             return "awb_green";
        //         } else if (rowData.colour_status == 'R') {
        //             return "awb_red";
        //         } else if (rowData.colour_status == 'O') {
        //             return "awb_orange";
        //         } else {
        //             return;
        //         }
        //     },
        // },
        { text: 'Organization Name', filtertype: 'input', datafield: 'org_Name', width: '25%', cellclassname: '', },
        {
            text: 'Organization Type', filtertype: 'checkedlist', datafield: 'org_type', width: '10%', cellclassname: '',
            filteritems: [
                { label: 'Airline', value: 'A' },
                { label: 'Forwarder', value: 'F' },
                { label: 'Handler', value: 'H' },
                { label: 'Trucking', value: 'T' },

            ],
        },
        { text: 'Registration Date', filtertype: 'input', datafield: 'register_date', width: '12%', cellclassname: '', },
        {
            text: 'Status', filtertype: 'checkedlist', datafield: 'activity_status', width: '10%', cellclassname: '',
            cellsrenderer: function (row, column, value) {
                if (value == 'A') {
                    return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> Active </div>';
                } else {
                    return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> Inactive </div>';
                }
            },
            filteritems: [
                { label: 'Active', value: 'A' },
                { label: 'Inactive', value: 'I' },

            ],
        },
        {
            text: 'Action',
            cellsrenderer: function () {
                return '<div class="grid_actions jqx-grid-cell-left-align"><img src="' + user + '" class="user_manage" /> <img src="' + switc + '" class="user_switch" /> <img src="' + reset + '" class="user_permission" /></div>';
            },
            width: '10%', filterable: false,
        },
        {
            text: 'Auth', datafield: 'auth', filtertype: 'checkedlist',
            filteritems: [
                { label: 'Active', value: 'A' },
                { label: 'Inactive', value: 'I' },

            ],
            // cellsrenderer: function () {
            //     return '<div class="grid_actions jqx-grid-cell-left-align"><img src="' + authn + '" class="row_edit" /> </div>';
            // },
            cellsrenderer: function (row, column, value) {
                if (value == 'A') {
                    return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> Active </div>';
                } else {
                    return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;"> Inactive </div>';
                }
            },
            width: '4%', filterable: false,
        },
        // {
        //     text: 'RCS / DEP',
        //     width: '7%',
        //     filterable: false,
        //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowData) {
        //         const pieces = parseFloat(rowData.pieces) || 0;
        //         const rcs = parseFloat(rowData.rcs_total_pieces_awb) || 0;
        //         let displayValue = `<div class="" style="margin-top: 13.5px;"><img src='${RedCross}' alt='Not Received' title='Not Received' /></div>`;
        //         if (rcs > 0) {
        //             displayValue = `${rcs} / ${pieces}`;
        //         }
        //         return `<div class="" style="margin-top: 13.5px;">${displayValue}</div>`;
        //     },
        // },
        // // { text: 'Flight', filtertype: 'textbox', datafield: 'flight_number_join', width: '9%', cellclassname: '', },
        // { text: 'Pieces', filtertype: 'textbox', datafield: 'pieces', width: '5%', cellclassname: '', },
        // { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '7%', cellclassname: '', },
        // { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '5%', cellclassname: '', },
        // { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '11%', cellclassname: '', },
        // {
        //     text: 'Truck',
        //     datafield: 'truck_no',
        //     filtertype: 'textbox',
        //     width: '9%',
        //     cellclassname: '',
        //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
        //         // if truck_no is empty, null, or undefined, fallback to rowdata.truck
        //         const displayValue = value && value.trim() !== '' ? value : (rowdata.truck || '');
        //         return `<div class="jqx-grid-cell-left-align" style="margin-top:13px;">${displayValue}</div>`;
        //     }
        // }
        // { text: 'Commodity', filtertype: 'textbox', datafield: 'commodity', width: '11%', cellclassname: '', },

    ];


    const gridData = {
        // Tabs: [],
        TabName: [], // {Active: [], Archives: []}
        Token: `SAToken`,
        page: 'org',
        EndPoint: 'sa-organization-list',
        Datafields: datafields,
        Columns: columns,
        nested: false,
        Options: {
            height: 1040,
            pageSize: 50,
            pagesizeoptions: ['50', '100', '200', '500'],
            selectionmode: 'checkbox',
        },
        colFunction: [
            { name: 'row_view', rowKey: 'org_id', },
            { name: 'row_edit', rowKey: 'org_id', },
            { name: 'row_delete', rowKey: 'org_id', },
            { name: 'user_manage', rowKey: 'org_id', },
            { name: 'user_switch', rowKey: 'org_id', },
            { name: 'user_permission', rowKey: 'org_id', },
        ]
    }

    const handleSwitch = async (apiData) => {
        console.log('id', apiData);
        let endPoint = '';
        let payload = {};
        let method = 'POST'
        if (apiData.section == 'user_switch') {
            endPoint = 'switch-user'
            payload = { org_id: apiData.data.org_id }
        } else if (apiData.section == 'user_manage') {
            setUserData(apiData.data.org_id)
            setUserManage(true)
            return;
        } else if (apiData.section == 'row_view' || apiData.section == 'row_edit') {
            endPoint = 'organization-details'
            payload = { org_id: apiData.data.org_id }
            // method = 'GET'
        } else if (apiData.section == 'row_delete') {
            setModalData(apiData.data)
            setModalConf(true)
            // method = 'GET'
        }
        if (endPoint === '') { return }

        // console.log('endPoint',method);
        CallApi({
            endPoint: endPoint,
            payload: payload,
            method: method,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    if (apiData.section == 'user_switch') {
                        sessionStorage.clear();
                        // const sendData = { ...innerData, loc: '/Dashboard', token_name: 'airlinetoken' }
                        // const sendData = { ...innerData, lastLoc: '/Dashboard', token_name: 'airlinetoken' }
                        // handleRedirect(sendData)
                        // history.push('/Dashboard')
                        let addUrl = {}
                        if(innerData?.org_type === 'H') {
                            window.location.replace('/HandlerAdmin')
                            // sessionStorage.setItem('loc', '/HandlerAdmin');
                            addUrl = {...innerData, loc: '/HandlerAdmin'}
                        } else if (innerData?.org_type === 'T') {
                            window.location.replace('/Trucker')
                            // sessionStorage.setItem('loc', '/Trucker');
                            addUrl = {...innerData, loc: '/Trucker'}
                        } else {
                            window.location.replace('/Dashboard')
                            // sessionStorage.setItem('loc', '/Dashboard');
                            addUrl = {...innerData, loc: '/Dashboard'}
                        }
                        AddSession('__A-', addUrl)
                    } else if (apiData.section == 'row_view') {
                        setModalData(innerData)
                        setConfModal(true)
                        setModalPos('V')
                    } else if (apiData.section == 'row_edit') {
                        setModalData(innerData)
                        setConfModal(true)
                        setModalPos('E')
                    }

                } else {
                    toast.error(res.data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
        // try {
        //     const res = await withRFSToken.post(endPoint, payload)
        //         .then(function (res) {
        //             const resCode = res.data.response_code;
        //             if (resCode === 200) {
        //                 const innerData = res.data.response_data;
        //                 const sendData = { ...innerData, loc: '/Dashboard', token_name: 'airlinetoken' }
        //                 handleRedirect(sendData)
        //                 // setFormData(initial)
        //                 // setOtp('')
        //             } else {
        //                 toast.error(res.data.response_msg);
        //             }
        //         });

        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    }
    // const handleRedeirect = (data) => {
    //     localStorage.clear();
    //     const setIfHasValue = (key, value) => {
    //         if (value !== null && value !== undefined && value !== "") {
    //             localStorage.setItem(key, value);
    //         }
    //     };
    //     if (data.airlinetoken && data.user_type && data.org_type) {
    //         console.log('id', data);
    //         setIfHasValue('User', data.user_name);
    //         setIfHasValue('UserID', data.user_id);
    //         setIfHasValue('UserType', data.user_type);
    //         setIfHasValue('UserNumber', data.user_number);
    //         setIfHasValue('LoginUser', data.login_user_type);
    //         setIfHasValue('OrgType', data.org_type);
    //         setIfHasValue('OrgName', data.org_name);
    //         setIfHasValue('Email', data.email_id);
    //         setIfHasValue('GoBack', data.back_url);
    //         // setIfHasValue('LogOut', logOutPath);
    //         // setIfHasValue('login_from', loginFrom);
    //         // setIfHasValue('truck_id', truckId);
    //         // setIfHasValue('CEmail', recEmail);
    //         // setIfHasValue('person', person);
    //         // setIfHasValue('key', key);
    //         setIfHasValue('orgLogo', data.org_logo);
    //         setIfHasValue('airlinetoken', data.airlinetoken);
    //         window.location.href = '/Dashboard';
    //     }
    // }

    const createOrg = () => {
        setModalData({})
        setConfModal(true)
        setModalPos('C')
    }

    const closeConf = () => {
        setConfModal(false);
        setModalData({});
    }

    const handleOnSearch = (string, results) => {
        // console.log('$$', string, results)
        if (/^[0-9\s-]*$/.test(string)) {
            let digits = string.replace(/\D/g, '');
            digits = digits.slice(0, 11);
            // setSearchValue(formatInput(digits));
        }
        // const formatted = formatInput(string);
        // setSearchValue(formatted);

    }

    const handleOnHover = (result) => {
        // console.log(result)
    }

    const handleOnSelect = async (item) => {
        // the item selected
        // console.log(item)
        // onSearch(item)
        setSearchValue(item)
        setModalData(prev => ({ ...prev, org_Name: item.id }))
    }

    const handleOnFocus = () => {
        // console.log('Focused')
    }

    const handleConfDelete = () => {

    }

    const formChange = (e) => {
        const { name, value } = e.target;
        setModalData(prev => ({ ...prev, [name]: value }))
    }

    const modalSubmit = () => {
        CallApi({
            endPoint: 'organization-update',
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    setReload(true)
                    toast.success(res.data.response_msg);
                } else {
                    toast.error(res.data.response_msg);
                }
            },
            onError: (msg) => {
                toast.error(msg)
            }
        });
        setTimeout(() => {
            setReload(false);
        }, 10);
    }

    return (
        <>
            {/* {console.log('um', modalPos)} */}
            {userManage ?
                <>
                    <UserManage data={userData} onBack={() => setUserManage(false)} />
                </>
                :
                <>
                    <div className="row">
                        <div className="col-md-6">
                            <div className='text-start'>
                                <button type="button" className="btn btn-primary addshipbtn" onClick={createOrg}>
                                    <FontAwesomeIcon icon={faPlus} /> Create Organization
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex gap-2 justify-content-end">
                                <div className='search'>
                                    <div className="form-group has-search">
                                        <ReactSearchAutocomplete
                                            autoFocus
                                            placeholder="Search"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                                            Organization Type <FontAwesomeIcon icon={faChevronDown} />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item href="#">All</Dropdown.Item>
                                            <Dropdown.Item href="#">Airline</Dropdown.Item>
                                            <Dropdown.Item href="#">Handler</Dropdown.Item>
                                            <Dropdown.Item href="#">Forwarder</Dropdown.Item>
                                            <Dropdown.Item href="#">Trucking</Dropdown.Item>
                                            <Dropdown.Item href="#">GSA</Dropdown.Item>
                                            <Dropdown.Item href="#">Broker</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>

                                <div>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                                            Creation Type <FontAwesomeIcon icon={faChevronDown} />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item href="/ULDControl/AddStock">New Stock</Dropdown.Item>
                                            {/* <Dropdown.Item href="/ULDControl/NewCharter">New Charter</Dropdown.Item> */}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>

                                <div>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='adduld'>
                                            Status <FontAwesomeIcon icon={faChevronDown} />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item href="/ULDControl/AddStock">New Stock</Dropdown.Item>
                                            {/* <Dropdown.Item href="/ULDControl/NewCharter">New Charter</Dropdown.Item> */}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>

                            </div>

                        </div>
                    </div>
                    <CommonGrid GD={gridData} onAction={handleSwitch} relaod={reload} />
                    {modalConf &&
                        <ConfModal
                            header={`Delete Organisation`}
                            subHeader={`Are you sure you want to delete this Organisation?`}
                            modalConf={handleConfDelete}
                            closeModal={() => setModalConf(false)}
                            primaryBtn='Delete'
                            secondaryBtn='Cancel'
                        />
                    }
                    <CommonModal
                        show={confModal}
                        onHide={closeConf}
                        title={`${modalPos === 'V' ? 'View' : modalPos === 'C' ? 'Create' : 'Edit'} Organisation`}
                        // subTitle='Are you sure you want to remove this history?'
                        className='modal_bgw primary_modal'
                        footer={
                            <div className='d-flex w-100 justify-content-between'>
                                {(modalPos === 'E' || modalPos === 'C') &&
                                    <>
                                        <Button variant="secondary" onClick={closeConf}> Cancel </Button>
                                        <Button variant="primary" className="ms-auto" onClick={modalSubmit}> {modalPos === 'E' ? 'Confirm' : 'Create'} </Button>
                                    </>
                                }
                            </div>
                        }
                    >
                        {modalPos === 'V' &&
                            <>
                                <div className="View_Organisation">
                                    <ul>
                                        <li className="detail_item">
                                            <label>Organisation Type:</label>
                                            <p>{modalData?.org_Type}</p>
                                        </li>
                                        <li className="detail_item">
                                            <label>Organisation Name:</label>
                                            <p>{modalData?.org_Name}</p>
                                        </li>
                                        <li className="detail_item">
                                            <label>First Name:</label>
                                            <p>{modalData?.contact_First_Name}</p>
                                        </li>
                                        <li className="detail_item">
                                            <label>Last Name:</label>
                                            <p>{modalData?.contact_Last_Name}</p>
                                        </li>
                                        <li className="detail_item">
                                            <label>Email Id:</label>
                                            <p>{modalData?.email_ID}</p>
                                        </li>
                                        <li className="detail_item">
                                            <label>Contact Number:</label>
                                            <p>{modalData?.contact}</p>
                                        </li>
                                        <li className="detail_item">
                                            <label>Organisation Address:</label>
                                            <p>{modalData?.main_Address}</p>
                                        </li>
                                        <li className="detail_item">
                                            <label>Station Code:</label>
                                            <p>{modalData?.station}</p>
                                        </li>
                                        <li className="detail_item">
                                            <label>Status:</label>
                                            <p>{modalData?.status}</p>
                                        </li>
                                    </ul>
                                </div>

                            </>
                        }
                        {(modalPos === 'E' || modalPos === 'C') &&
                            <>
                                <Form.Group as={Row}>
                                    <Col sm={6}>
                                        <Form.Label>Organisation Type : <span className='red'>*</span></Form.Label>
                                        <Select
                                            options={orgType}
                                            onChange={(selected) => {
                                                setModalData(prev => ({ ...prev, org_Type: selected.value, org_Name: '' }))
                                                setSearchValue({})
                                            }}
                                            placeholder="Select Type"
                                            className=''
                                            name="role"
                                            value={orgType?.find(tp => tp.value == modalData.org_Type) || null}
                                            isDisabled={modalPos === 'E'}
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Label>Organisation Name :<span className='red'>*</span></Form.Label>
                                        {modalData?.org_Type === 'A' ?
                                            <ReactSearchAutocomplete
                                                items={getAorgName}
                                                onSearch={handleOnSearch}
                                                onHover={handleOnHover}
                                                onSelect={handleOnSelect}
                                                onFocus={handleOnFocus}
                                                inputSearchString={searchValue?.name}
                                                // inputProps={{ maxLength: 13 }}
                                                autoFocus
                                                className=""
                                                placeholder=''
                                            />
                                            :
                                            <Form.Control
                                                type='text'
                                                name='org_Name'
                                                value={modalData?.org_Name}
                                                onChange={formChange}
                                            />
                                        }

                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Col sm={6}>
                                        <Form.Label>First Name :</Form.Label>
                                        <Form.Control
                                            type='text'
                                            name='first_Name'
                                            value={modalData?.first_Name}
                                            onChange={formChange}
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Label>Last Name :</Form.Label>
                                        <Form.Control
                                            type='text'
                                            name='last_Name'
                                            value={modalData?.last_Name}
                                            onChange={formChange}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Col sm={6}>
                                        <Form.Label>Email Id : <span className='red'>*</span></Form.Label>
                                        <Form.Control
                                            type='text'
                                            name='email_ID'
                                            value={modalData?.email_ID}
                                            onChange={formChange}
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Label>Contact Number :</Form.Label>
                                        <Form.Control
                                            type='number'
                                            name='cell_Phone'
                                            value={modalData?.cell_Phone}
                                            onChange={formChange}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Col sm={6}>
                                        <Form.Label>Organisation Address : <span className='red'>*</span></Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            name='main_Address'
                                            value={modalData?.main_Address || ''}
                                            onChange={formChange}
                                            rows={3}
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Label>Organisation Address2 :</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Col sm={6}>
                                        <Form.Label>City :<span className='red'>*</span></Form.Label>
                                        <Form.Control
                                            type='text'
                                            name='city'
                                            value={modalData?.city}
                                            onChange={formChange}
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Label>Country :<span className='red'>*</span></Form.Label>
                                        <Form.Control
                                            type='text'
                                            name='country'
                                            value={modalData?.country}
                                            onChange={formChange}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Col sm={6}>
                                        <Form.Label>Station Code :<span className='red'>*</span></Form.Label>
                                        <Select
                                            options={getDestination}
                                            onChange={(selected) => setModalData(prev => ({ ...prev, station: selected.value })
                                            )}
                                            placeholder="Select Type"
                                            className=''
                                            name="station"
                                            value={getDestination?.find(tp => tp.value == modalData.station) || null}
                                            isDisabled={modalPos === 'E'}
                                        />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Label>Postal Code :</Form.Label>
                                        <Form.Control
                                            type='number'
                                            name='postal_code'
                                            value={modalData?.postal_code}
                                            onChange={formChange}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                    <Col sm={6}>
                                        <Form.Label> Status :</Form.Label>
                                        <div>
                                            <Form.Check
                                                inline
                                                type='radio'
                                                label="Active"
                                                name="group1"
                                                id="group1"
                                                checked={modalData?.status === 'A'}
                                                onChange={() => setModalData(prev => ({ ...prev, status: 'A' }))}
                                            />
                                            <Form.Check
                                                inline
                                                type='radio'
                                                label="Inactive"
                                                name="group2"
                                                id="group2"
                                                checked={modalData?.status === 'I'}
                                                onChange={() => setModalData(prev => ({ ...prev, status: 'I' }))}
                                            />
                                        </div>
                                    </Col>
                                </Form.Group>
                            </>
                        }
                    </CommonModal>
                </>
            }
        </>
    )
}

export default Organisation